import styled from 'styled-components';
import EditTimesTooltip from './EditTimesTooltip';

export default styled(EditTimesTooltip)`
  && {
    max-width: none !important;
    .tippy-content {
      overflow: visible;
    }
  }

  .content {
    padding: 0.8rem;
    display: flex;
    align-items: center;
  }

  .field-group {
    margin-right: 8px;
    display: flex;
  }

  .button-group {
    flex: 0;
  }

  .field {
    width: 80px;
  }

  .field + .field {
    margin-left: -1px;
  }
`;
